import {
	Component,
	OnDestroy,
	OnInit,
	ChangeDetectionStrategy,
} from '@angular/core';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { Router, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectUser, State } from '@lmc-app/store';
import { User } from '@lmc-app/shared/interface/user.interface';
import { Subject, takeUntil } from 'rxjs';
import { NgFor, DatePipe } from '@angular/common';

//import { MatDialog } from '@angular/material/dialog'

@Component({
	selector: 'app-read',
	templateUrl: './read.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./read.component.scss'],
	imports: [NgFor, RouterLink, DatePipe],
})
export class ReadComponent implements OnInit, OnDestroy {
	readData: any; // This is to use it on hmtl to display information getAllData()
	private readonly _onDestroy = new Subject<void>();

	constructor(
		private apiService: LegacyApiService,
		private _router: Router,
		private store: Store<State>
	) {
		this.apiService.getClickEvent().subscribe(() => {
			console.log('Refresh Display');
			this.getAllData();
		});
	}

	ngOnInit(): void {
		// Subscribe to user from NgRx store
		this.store
			.select(selectUser)
			.pipe(takeUntil(this._onDestroy))
			.subscribe((user: User | null) => {
				if (user) {
					// User is authenticated, load data
					this.getAllData();
				}
			});
	}

	ngOnDestroy(): void {
		this._onDestroy.next();
		this._onDestroy.complete();
	}

	// Delete the record/applicant row
	deleteID(id: any) {
		if (confirm('Are you sure, you want to delete the client selected?')) {
			//console.log(id, "delete==>");
			this.apiService.deleteData(id).subscribe((res) => {
				//console.log(res, "inside==>");
				this.getAllData();
			});
		}
	}

	// Display the data on the applicants on the user management portal
	getAllData() {
		this.apiService.getAllData().subscribe((res) => {
			this.readData = res.data;
		});
	}
}
